import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as NodataIcon } from "../../../common/images/svg/Nodata.svg";
import { SearchCustom } from "../../../components/inputs/search/searchCustom";

const CompanyDefault = ({
  setOpenCompanyDefault,
  dataCompaniesDefault = [],
  companyDefaultSelected,
  onChange,
  setSearchDefaultCompany,
  loadingDefaulCompany,
}: {
  setOpenCompanyDefault: React.Dispatch<React.SetStateAction<boolean>>;
  dataCompaniesDefault: any[];
  companyDefaultSelected: any;
  onChange: (_item: any) => void;
  setSearchDefaultCompany: React.Dispatch<any>;
  loadingDefaulCompany: boolean;
}) => {
  const [searchName, setSearchName] = useState<string>("");
  const [clickSearch, setClickSearch] = useState(false);

  const handleSearch = (value: string) => {
    setClickSearch(true);
    setSearchName(value);
  };

  useEffect(() => {
    if (!clickSearch) return;
    const handler = setTimeout(() => {
      setSearchDefaultCompany(searchName);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [searchName, clickSearch]);

  return (
    <div className="company_default">
      <SearchCustom
        value={searchName}
        placeholder="Search by name"
        onChange={handleSearch}
        onSubmit={handleSearch}
        className="search-company-default"
      />
      {loadingDefaulCompany ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "236px",
          }}
        >
          <Spin size={"large"} className="custom-spin" />
        </div>
      ) : (
        <>
          {dataCompaniesDefault?.length ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                height: "236px",
              }}
            >
              {dataCompaniesDefault.map((item) => (
                <div
                  key={item?.id}
                  className="company_default-item"
                  onClick={() => {
                    onChange(item);
                    setOpenCompanyDefault(false);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 700,
                        color:
                          companyDefaultSelected?.id === item.id
                            ? "#1DABF1"
                            : "white",
                      }}
                    >
                      {item.name}
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color:
                            companyDefaultSelected?.id === item.id
                              ? "#1DABF1"
                              : "white",
                        }}
                      >
                        {item.name}
                      </span>
                      <div className="dot-transaction"></div>
                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color:
                            companyDefaultSelected?.id === item.id
                              ? "#1DABF1"
                              : "white",
                        }}
                      >
                        {item.country}
                      </span>
                    </div>
                  </div>
                  {companyDefaultSelected?.id === item.id && (
                    <CheckSelectIcon />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{
                padding: "0 16px",
                display: "flex",
                flexDirection: "row",
                gap: 12,
                width: "100%",
              }}
            >
              <div
                className="empty-transaction"
                style={{ minHeight: "236px " }}
              >
                <div className="ant-empty-image">
                  <NodataIcon />
                </div>
                <div
                  className="ant-empty-description"
                  style={{ color: "white" }}
                >
                  No data
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default CompanyDefault;
